const OPSZ_FLOOR = 20;
const OPSZ_CEIL = 48;
const WGHT_REST = 400;
const COMP_RANGE = 200;
const GRAD_EXPONENT = 1.4;
const WGHT_EXPONENT = 1.3;
/** Google: light-on-dark reads heavy. Applied on GRADE only. */
const GRAD_DARK = -25;
const CSS_PX_FLOOR = 10;

function clamp(n: number, min: number, max: number) {
  return Math.min(max, Math.max(min, n));
}

/**
 * Optical compensation for drawing Material Symbols below the opsz floor.
 *
 * Material authors opsz at ≥20. CDS paints 10 / 12 / 14 CSS px. GRADE is the
 * primary lever (apparent weight, almost no box growth). wght is secondary
 * once GRADE approaches 200. Dark mode subtracts 25 from GRADE only.
 */
export function iconAxes(cssPx: number, { dark = false }: { dark?: boolean } = {}) {
  const px = Math.max(CSS_PX_FLOOR, cssPx);
  const opsz = clamp(px, OPSZ_FLOOR, OPSZ_CEIL);
  const deficit = Math.max(0, OPSZ_FLOOR - px);
  const t = deficit / 10;
  const gradSub = COMP_RANGE * t ** GRAD_EXPONENT;
  const wghtSub = COMP_RANGE * t ** WGHT_EXPONENT;

  return {
    opsz,
    wght: Math.round(WGHT_REST + wghtSub),
    GRAD: Math.round(gradSub + (dark ? GRAD_DARK : 0)),
  };
}
